module.exports = __webpack_public_path__ + "static/media/no-preservatives.f78f4c2f.svg";